import styled from '@emotion/styled';
import { ifNotProp, ifProp } from 'styled-tools';
import { breakpoints } from '~/theme';

export const StyledFilterHeaderWrapper = styled.div(({ theme }) => ({
	position: 'sticky',
	top: 0,
	zIndex: 176,
	backgroundColor: theme.colors.white,

	[breakpoints.sm]: {
		position: 'relative',
	},
}));

export const StyledFacetAndSortingOptionsWrapper = styled.div(({ theme }) => ({
	display: 'block',
	position: 'relative',

	'&:after': {
		content: '""',
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		height: '1px',
		background: theme.colors.border,
	},
}));

export const StyledFacetAndSortingOptions = styled.div(({ theme }) => ({
	paddingTop: theme.space[4],
	paddingBottom: theme.space[4],
}));

export const StyledFacetsAndSortingWrapper = styled.div<{ hasSorting?: boolean }>(
	({ theme }) => ({
		display: 'grid',
		alignItems: 'center',
		top: 0,
		zIndex: 176,
		paddingTop: theme.space[3],
		paddingBottom: theme.space[3],
		borderBottom: `solid 1px ${theme.colors.border}`,

		[breakpoints.sm]: {
			gap: theme.space[7],
		},

		'> :last-child': {
			textAlign: 'right',
		},
	}),
	ifProp(
		'hasSorting',
		{
			gridTemplateColumns: '1fr 1fr 1fr',

			[breakpoints.md]: {
				gridTemplateColumns: '1fr auto auto',
			},
		},
		{
			gridTemplateColumns: '1fr 1fr',

			[breakpoints.md]: {
				gridTemplateColumns: '1fr auto',
			},
		},
	),
);

export const StyledFacetsList = styled.div({
	display: 'none',

	[breakpoints.lg]: {
		display: 'block',
	},
});

export const StyledQuantity = styled.div(({ theme }) => ({
	display: 'grid',
	alignItems: 'center',
	fontSize: theme.fontSizes.xs,
	color: theme.colors.grey60,
	textAlign: 'center',
}));

export const StyledProductListWrapper = styled.div<{ noMargin: boolean }>(
	ifNotProp('noMargin', ({ theme }) => ({
		marginTop: theme.space[7],

		[breakpoints.xs]: {
			marginTop: theme.space[3],
		},
	})),
);

export const StyledPaginationWrapper = styled.div(({ theme }) => ({
	marginTop: theme.space[6],
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	fontSize: theme.fontSizes.xs,

	'& > * + *': {
		marginTop: '5px',
	},
}));

export const StyledCaption = styled.span(({ theme }) => ({
	color: theme.colors.grey60,
}));
